export default "__VITE_ASSET__RhfbyOaM__"